import { render, staticRenderFns } from "./extInfopanel.vue?vue&type=template&id=03c04368&scoped=true&"
import script from "./extInfopanel.vue?vue&type=script&lang=js&"
export * from "./extInfopanel.vue?vue&type=script&lang=js&"
import style0 from "./extInfopanel.vue?vue&type=style&index=0&id=03c04368&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c04368",
  null
  
)

export default component.exports